import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import GuestListLayer from "../../components/GuestList/GuestListLayer";

const GuestList = () => {
    return (
        <>
            <MasterLayout>
                <Breadcrumb title="Guest List" />
                <GuestListLayer
                    status=""
                    viewBasePath="/GuestList"
                />
            </MasterLayout>
        </>
    );
};

export default GuestList;